var btsUI = angular.module("bootstrap.ui", []);

require('./articles/header.js')(btsUI);
require('./articles/footer.js')(btsUI);
require('./articles/sidebar.js')(btsUI);
require('./articles/chevron.js')(btsUI);
require('./articles/tooltip.js')(btsUI);
require('./articles/dateRange.js')(btsUI);
require('./articles/calendar.js')(btsUI);
require('./articles/loadingBar.js')(btsUI);

require('./articles/providers/providerDetails/providerDetails')(btsUI);
require('./articles/providers/detailsSidebar/detailsSidebar')(btsUI);
require('./articles/providers/detailsMap/detailsMap')(btsUI);
require('./articles/providers/glossary/glossary')(btsUI);
require('./articles/providers/UPMC/UPMC')(btsUI);
require('./articles/providers/providerDisclaimer')(btsUI);
require('./articles/providers/providerDetailSiteDisclaimer')(btsUI);
require('./articles/providers/vbidView')(btsUI);
require('./articles/spendingAccountSummary.js')(btsUI);

//require('./directives/dateInput.js')(btsUI);
require('./directives/directives.js')(btsUI);
require('./directives/smartStack')(btsUI);
require('./directives/passwordStrength')(btsUI);
require('./directives/mapView')(btsUI);
require('./directives/autocomplete')(btsUI);
require('./directives/providerImage')(btsUI);
require('./directives/ribbonRating')(btsUI);
require('./directives/starRating')(btsUI);
require('./directives/reviewList')(btsUI);
require('./directives/overallReviews')(btsUI);
require('./directives/requiresLogin')(btsUI);
require('./directives/clickableStars')(btsUI);
require('./directives/favorites')(btsUI);
require('./directives/drawer.js')(btsUI);
require('./directives/hmhs/clxDrawer.js')(btsUI);
require('./directives/affirm')(btsUI);
require('./directives/reviews/newReview')(btsUI);
require('./directives/reviews/reviewDisclaimer')(btsUI);
require('./directives/reviews/allReviews')(btsUI);
require('./directives/networkStatus')(btsUI);
require('./directives/acceptingNewPatients')(btsUI);
require('./directives/homeHealthProvider')(btsUI);
require('./directives/buttonBuilder')(btsUI);
require('./directives/buttonBuilderLink')(btsUI);
require('./directives/makeMyPCP')(btsUI);
require('./directives/currencyInputFormatter')(btsUI);
require('./directives/medicareRating')(btsUI);
require('./directives/scrollContainer')(btsUI);
require('./directives/scrollTo')(btsUI);
require('./directives/stateSelect')(btsUI);
require('./directives/youtubeVideoPlayer')(btsUI);
require('./directives/invalidInputFocus')(btsUI);
require('./directives/newPassword')(btsUI);
require('./directives/customSsnValidate')(btsUI);
require('./directives/progressiveScroll')(btsUI);
require('./directives/planProgress')(btsUI);
require('./directives/progressMeter')(btsUI);
require('./directives/idCard')(btsUI);
require('./directives/VBID')(btsUI);
require('./directives/tierStatus')(btsUI);
require('./directives/vitalsSmartshopper')(btsUI);
require('./directives/loginBox')(btsUI);
require('./directives/dateValidation')(btsUI);
require('./directives/equalToValidator')(btsUI);
require('./directives/requestAppointmentForm')(btsUI);
require('./directives/btsFormMessagesGenerator')(btsUI);
require("./directives/btsDateOfBirthValidation.js")(btsUI);
require('./directives/imageSwapper')(btsUI);
require('./directives/btsDateField')(btsUI);
require('./directives/btsDateMinMax')(btsUI);

require('./directives/hmhs/tableListing')(btsUI);
require('./directives/hmhs/feedbackFlash')(btsUI);
require('./directives/hmhs/pageHeadline')(btsUI);
require('./directives/hmhs/clientSideBar')(btsUI);
require('./directives/hmhs/clientSideBarForm')(btsUI);
require('./directives/hmhs/clientHeader')(btsUI);
require('./directives/hmhs/clientFooter')(btsUI);
require('./directives/hmhs/clientSideBarOnePage')(btsUI);
require('./directives/hmhs/pagination')(btsUI);
require('./directives/hmhs/draggable')(btsUI);
require('./directives/hmhs/dropable')(btsUI);
require('./directives/hmhs/generate-graphs')(btsUI);
require('./directives/hmhs/mobileTable')(btsUI);

require('./directives/cms/btsCmsImg')(btsUI);

require('./directives/ebusiness/sidebarNavigation')(btsUI);

//AEM Directives
require('./directives/aem/footer/footerComponent')(btsUI);
require('./directives/aem/header/headerComponent')(btsUI);
require('./directives/aem/header/displayRulesEngine')(btsUI);
require('./directives/aem/languageBar/languageBar')(btsUI);
require('./directives/aem/healthTools/healthTool')(btsUI);
require('./directives/aem/healthTools/toolContainer')(btsUI);
require('./directives/aem/btsCoupling')(btsUI);
require('./directives/aem/healthTools/utilServices')(btsUI);
require('./directives/aem/healthTools/toolContainer')(btsUI);
require('./directives/aem/postHeaderProvLinkItem/postHeaderProvLinkItem')(btsUI);



require('./articles/validation.js')(btsUI);
require('./articles/required.js')(btsUI);
require('./articles/pagination.js')(btsUI);

require('./articles/backToTop.js')(btsUI);
